<template>
    <input
        autocomplete="off"
        class="form-control"
        @input="e => $emit('input', e.target.value)"
        placeholder="Password"
        type="password"
        :value="value"
    >
</template>

<script>
export default {
    name: 'PasswordInput',

    props: {
        value: {
            required: true,
            type: String,
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Users/LoginOrSignup/Inputs/Password.vue